// extracted by css-extract-rspack-plugin
export default {"root":"DGXvza0Uxv4JpNwk","icon":"S_Bc5qZYwHI8LhZJ","content":"qVqr80Cppvkc362z","monoContent":"QeEhzMb2uo2jIxJN"};